import { parseDateSafe, zodTransformFirestoreTimestampToDate } from "../../../utils/zodUtils.mjs";
import { zodFlavorId } from "../../ids.mjs";
import { defineFirestoreCollection } from "../../firebaseCollectionSchema.mjs";
import { PiiCategory, meta } from "../../meta.mjs";
import { executionTraceStampSchema } from "../../executionTrace.mjs";
import { VendorSyncOps } from "../../vendorSync/vendorSync.mjs";
import { DateTime } from "luxon";
import { z as z$1 } from "zod";

// src/models/vendors/bridge/policy.ts
const firestoreDate = z$1.any().transform(zodTransformFirestoreTimestampToDate);
/** Bridge Policy v2 status values observed from Bridge API. */
const bridgePolicyStatusSchema = z$1.enum([
	"PENDING",
	"UNKNOWN",
	"CONFIRMED",
	"REVALIDATING",
	"INVALID"
]);
const bridgePolicyStatusPollKindSchema = z$1.enum(["create", "revalidate"]);
const bridgePolicyStatusPollOutcomeSchema = z$1.enum(["timeout"]);
/** Server-owned poll series overlay (create + revalidate). */
const bridgePolicyStatusPollSchema = z$1.object({
	kind: bridgePolicyStatusPollKindSchema,
	startedAt: firestoreDate,
	deadlineAt: firestoreDate,
	seriesId: z$1.string(),
	lastAttempt: z$1.number().int().nonnegative().optional(),
	outcome: bridgePolicyStatusPollOutcomeSchema.optional()
});
/**
* Bridge policy observed doc — doc id = our sync id (Bridge `externalId`).
* Path: `bridge_policies/{policyId}`. Native Bridge id is `vendorNativeId` (`pol_…`).
*/
const bridgePolicySchema = z$1.object({
	id: zodFlavorId(),
	customerId: zodFlavorId(),
	vendorNativeId: zodFlavorId().optional(),
	status: bridgePolicyStatusSchema,
	payerId: z$1.string().nullish(),
	memberId: meta(z$1.string().nullish(), { pii: { category: "medicalId" } }),
	state: z$1.string().nullish(),
	planName: z$1.string().nullish(),
	snapshot: meta(z$1.record(z$1.string(), z$1.unknown()).optional(), {
		bqType: "stringified_map",
		pii: { category: "health" }
	}),
	validatedAt: firestoreDate.optional(),
	statusPoll: bridgePolicyStatusPollSchema.optional(),
	observedAt: firestoreDate.optional(),
	createdAt: firestoreDate,
	updatedAt: firestoreDate,
	executionTrace: executionTraceStampSchema.optional()
});
/** Payer confirmation freshness window for attach / ensure-valid (one calendar year). */
const BRIDGE_POLICY_VALIDATION_REUSE_YEARS = 1;
function isBridgePolicyValidatedWithinReuseWindow(validatedAt, now = /* @__PURE__ */ new Date()) {
	const date = parseDateSafe(validatedAt);
	if (!date) return false;
	const cutoff = DateTime.fromJSDate(now, { zone: "utc" }).minus({ years: 1 });
	return DateTime.fromJSDate(date, { zone: "utc" }) > cutoff;
}
const BridgePolicies = defineFirestoreCollection("bridge_policies", bridgePolicySchema, { ops: VendorSyncOps }, {
	dwReplication: true,
	firestoreCollectionPath: "bridge_policies",
	executionTrace: true
});

export { BRIDGE_POLICY_VALIDATION_REUSE_YEARS, BridgePolicies, bridgePolicySchema, bridgePolicyStatusPollKindSchema, bridgePolicyStatusPollOutcomeSchema, bridgePolicyStatusPollSchema, bridgePolicyStatusSchema, isBridgePolicyValidatedWithinReuseWindow };
//# sourceMappingURL=policy.mjs.map